var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 34,
    viewBox: "0 0 45 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 5.85546C44.7671 6.12505 44.5768 6.3863 44.3467 6.61142C35.187 15.5802 26.0159 24.5378 16.8731 33.5232C16.2057 34.1791 15.8308 34.143 15.1889 33.5093C10.3292 28.7095 5.44403 23.9347 0.541787 19.1765C-0.0688635 18.5846 -0.256319 18.201 0.470781 17.5284C2.25729 15.8775 3.98415 14.1599 5.6883 12.4257C6.21658 11.8893 6.51764 11.9504 7.02037 12.4479C9.53965 14.9576 12.093 17.4312 14.635 19.9186C15.5685 20.8321 16.4869 20.8478 17.3901 19.9659C23.9794 13.5207 30.5659 7.07278 37.1524 0.627637C38.0234 -0.224675 38.9115 -0.208927 39.8166 0.674884C41.3219 2.1479 42.8272 3.61814 44.3269 5.09394C44.5569 5.32184 44.7557 5.57753 45 5.85268V5.85546Z",
    fill: "#019045"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/done_icon.ca9e14c4280b667cc5d91e22cde22750.svg";
export { ForwardRef as ReactComponent };